import React from 'react';
import styled from 'styled-components';

const DropOffDetailsContainer = styled.div`
  background: white;
  justify-content: center;
  display: flex;
`;

export default ({ className, ...rest }) => <DropOffDetailsContainer className={className} {...rest} />;
